import { Box, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import ConstFilterElements from '../const-filter-elements';
import { SelectFilterProps } from './dto';
import { FormattedMessage } from 'react-intl';
import { GenericTableFilterView } from 'inside-fifa/api/generic-tables/dto';

const SelectFilter: React.FC<SelectFilterProps> = (props) => {
    return (
        <ConstFilterElements
            setSelectedDataColumn={props.setSelectedDataColumn}
            selectedDataColumn={props.selectedDataColumn}
            isShowOutsideChecked={props.isShowOutsideChecked}
            dataColumns={props.dataColumns}
            setShowOutsideChecked={props.setShowOutsideChecked}
            label={props.label}
            setLabel={props.setLabel}
            languages={props.languages}
            isHideOptionAll={props.isHideOptionAll}
            setHideOptionAll={props.setHideOptionAll}
            isShowHideOptionAllSelector = {props.isShowHideOptionAllSelector}
        >
            <>
                <Box display="grid" sx={{ py: 1 }}>
                    <InputLabel>View:</InputLabel>
                    <Select
                        aria-label="view"
                        fullWidth
                        value={props.selectedViewKey}
                        onChange={(e) => props.setSelectedViewKey(e.target.value as GenericTableFilterView)}
                    >
                        {props.viewFormats?.map((format) => (
                            <MenuItem key={format.key} value={format.key}>
                                {format.placeholder}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
                <Box display="grid" sx={{ py: 1 }}>
                    <InputLabel>
                        <FormattedMessage id="inside-fifa.generic-tables.filters.all-options-label" />
                    </InputLabel>
                    {props.languages.map((language) => (
                        <Box key={language} display="flex" alignItems="center" sx={{ py: 1 }}>
                            <TextField
                                aria-label={`All Options Label for ${language}`}
                                label={language}
                                fullWidth
                                value={
                                    props.allOptionsLabel && props.allOptionsLabel[language]
                                        ? props.allOptionsLabel[language]
                                        : undefined
                                }
                                onChange={(e) => {
                                    props.setAllOptionsLabel({
                                        ...props.allOptionsLabel,
                                        [language]: e.target?.value,
                                    });
                                }}
                            />
                        </Box>
                    ))}
                </Box>
            </>
        </ConstFilterElements>
    );
};

export default SelectFilter;
